import {Directive, ElementRef, Input, Renderer2, AfterViewInit} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[textSlideUp]'
})
export class SlideUpDirective implements AfterViewInit {
  @Input() delay: number;
  @Input() sequence: 'slideUp1' | 'slideUp2' = 'slideUp1'; // Add sequence input
  @Input() animationDuration: number;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Wait until the view is fully initialized before accessing text content
    this._wrapContent();
    this.init();
  }

  private _wrapContent() {
    const text = this.el.nativeElement.textContent.trim();
    let words = text.split(' ');
    let delayCounter = 0;
    let content = '';

    words.forEach((word) => {
      delayCounter += this.delay;
      content += `<span style="animation-delay: ${delayCounter}ms" class="animated-char">${word}</span>`;

      if (content !== '') content += ' ';
    });

    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', content);
    this.renderer.setStyle(this.el.nativeElement, 'animation-duration', `${this.animationDuration}ms`);
  }

  init() {
    setTimeout(() => {
      this.renderer.addClass(this.el.nativeElement, 'show');
    }, this.delay);

    // Handle sequencing manually if needed
    if (this.el.nativeElement.dataset.animate === 'slideUp1') {
      const nextElement = this.el.nativeElement.nextElementSibling;
      if (nextElement) {
        setTimeout(() => {
          nextElement.classList.add('show');
        }, this.animationDuration); // Delay based on animationDuration
      }
    }
  }
}
